"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var colors = {
    localhost: "#d940a1",
    "staging.remota.app": "#24695B",
    "trial.remota.app": "#325A95",
    "sandbox.remota.app": "#A66111",
    "remota.app": "#C81D09",
};
var Icon = function (_a) {
    var size = _a.size;
    var _b = __read(react_1.default.useState(""), 2), color = _b[0], setColor = _b[1];
    (0, react_1.useEffect)(function () {
        setColor(colors[location.hostname] || colors["remota.app"]);
    }, []);
    return react_1.default.createElement(LogoArea, { size: size }, color ? react_1.default.createElement(RemotaLogo, { color: color }) : null);
};
exports.Icon = Icon;
var LogoArea = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n"], ["\n  width: ", ";\n  height: ", ";\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n"])), function (props) { return (props.size === "x-small" ? "16px" : "32px"); }, function (props) { return (props.size === "x-small" ? "16px" : "32px"); });
var RemotaLogo = react_1.default.memo(function (_a) {
    var color = _a.color;
    return (react_1.default.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.0128 1.70001L30.4 12.2379V28.7H16.0128V23.3366C18.8536 23.3366 21.1565 21.0336 21.1565 18.1928C21.1565 15.352 18.8536 13.0491 16.0128 13.0491V1.70001ZM16.0128 15.952V13.0491H16.0127L16.0127 1.70001L1.60001 12.2379V28.7H16.0127L16.0127 23.3366H16.0128V20.4337C17.2503 20.4337 18.2536 19.4304 18.2536 18.1928C18.2536 16.9553 17.2503 15.952 16.0128 15.952ZM16.0127 15.952L16.0127 13.0491C13.1719 13.0491 10.869 15.352 10.869 18.1928C10.869 21.0337 13.1719 23.3366 16.0127 23.3366L16.0127 20.4337C16.0127 20.4337 16.0127 20.4337 16.0127 20.4337C14.7751 20.4337 13.7719 19.4304 13.7719 18.1928C13.7719 16.9553 14.7751 15.952 16.0127 15.952C16.0127 15.952 16.0127 15.952 16.0127 15.952Z", fill: color })));
});
var templateObject_1;
